import React, { Component } from "react";
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  render() {
    return (
      <header>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className="head-logo">
                <img src={require("../../static/images/mobile/ynet.png")} />
                {/* <div className="ynet"></div> */}
                <div className="head-text">בחירות 
                  <span>2022</span>
                </div>
                <div className="head-line"></div>
              </div>
              <div className="main-title">הכנסת ה-25</div>
              {Object.keys(this.props.currentParty).length !==  0 ?
              <div className="remeark">
                <span className="chair">לחצו על הכיסאות</span>
                <span>וגלו מי צפויים להיות הח"כים הבאים</span>
              </div>:""}              
            </div>
          </div>
        </div>
        {/* <div className="negishut_float" onClick={openNegishut}></div> */}
      </header>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Header/Header.jsx